// Ficha del negocio del admin (reorden admin F2, 24-oct-2026): junta en una pantalla lo que vivía en 4
// (Usuarios → Suscripciones → Módulos → Adopción). Todos los endpoints existían salvo /resumen (cifras).
import { baseApi } from './baseClient';

export interface TenantRow {
  id: number; slug: string; name: string; status: string; plan: string | null; is_pro: number;
  vertical: string | null; timezone: string | null; created_at: string; custom_domain: string | null;
  pos_tenant_id: number | null; platform_brand: string | null; onboarded: number;
  logo_url: string | null;
}
export interface ModuloRow {
  module_key: string; name: string; kind: string; vertical: string | null; is_core: number;
  entitled: number; enabled: number; applies: number;
}
export interface UsuarioRow { id: number; role: string; name: string | null; email: string; is_active: number }

export interface SuscripcionRaw {
  plan_code: string; status: string; started_at: string | null; expires_at: string | null;
  payment_method: string | null; is_trial: number | boolean; max_branches: number; custom_price: number | null;
  is_pro: boolean; days_left: number | null; expired: boolean; price: number; currency: string;
  autopay_status?: string | null; _implicit?: boolean;
}
export interface PagoRaw {
  id: number; plan_code: string | null; amount: string | number; currency: string; method: string; status: string;
  created_at: string; period_start: string | null; period_end: string | null;
}
export interface Resumen {
  contactos: { total: number; activos: number; ultimo_alta: string | null };
  visitas: { total: number; d30: number; ultima: string | null };
  canjes: { total: number; d30: number; ultimo: string | null };
  ultimo_login: string | null;
  whatsapp_30d: { enviados: number; ok: number; ultimo: string | null };
  campanas_30d: { n: number; ultima: string | null };
}
export interface WhatsAppInfo { config: { base: string; session: string } | null; status: Record<string, unknown> | null }
export interface PosInfo { linked: boolean; pos_tenant_id?: number; available?: boolean; error?: string; name?: string }

export const adminNegocioApi = {
  tenant: (id: string) => baseApi.get<{ tenant: TenantRow; modules: ModuloRow[]; users: UsuarioRow[] }>(`/admin/tenants/${id}`),
  suscripcion: (id: string) => baseApi.get<{ subscription: SuscripcionRaw; payments: PagoRaw[] }>(`/admin/tenants/${id}/subscription`),
  resumen: (id: string) => baseApi.get<Resumen>(`/admin/tenants/${id}/resumen`),
  whatsapp: (id: string) => baseApi.get<WhatsAppInfo>(`/admin/tenants/${id}/whatsapp`),
  pos: (id: string) => baseApi.get<PosInfo>(`/admin/tenants/${id}/pos`),
};
